import { ConfirmationDialog, ModalInjectedProps } from '@sketch/components'
import React from 'react'

import { useShareDeleteWithUi } from './useShareDeleteWithUi'
import { useEventDispatch } from '@sketch/utils'

interface DeleteShareModalProps extends ModalInjectedProps {
  name: string
  shareShortId: string
  workspaceId: string
  projectId?: string
}

export const DeleteShareModal: React.FCC<DeleteShareModalProps> = props => {
  const { name, hideModal, isModalOpen, shareShortId, workspaceId, projectId } =
    props
  const [deleteShare, { loading }] = useShareDeleteWithUi({
    onCompleted: hideModal,
  })

  const dispatchShareRefresh = useEventDispatch('workspaceShareRefresh')

  dispatchShareRefresh({
    workspaceIdentifier: workspaceId,
    projectIdentifier: projectId,
  })

  return (
    <ConfirmationDialog
      title="Move to Trash?"
      hideModal={hideModal}
      isModalOpen={isModalOpen}
      cancelButton={{
        disabled: loading,
      }}
      confirmButton={{
        text: 'Move to Trash',
        variant: 'negative',
        loading,
        disabled: loading,
      }}
      onConfirm={() => deleteShare({ identifier: shareShortId })}
    >
      <>
        <p>
          Move “<strong>{name}”</strong> to Trash?
        </p>
        <p>
          Documents in Trash will be permanently deleted after 90 days.
          Workspace Members with access can still see it in Trash.
        </p>
      </>
    </ConfirmationDialog>
  )
}
